import React from "react";
import { Col, Row } from "reactstrap";

export const HeaderResourceCompleted = () => {
  return (
    <>
      <div className="header-gradient"></div>

      <Row className="resource-completed-container">
        <Col className="text-center resource-header" xs={10} md={4}>
          <div className="title-resource-completed">
            Ya completaste este recurso
          </div>
          <div className="subtitle-resource-completed mt-5">
            <p>Solo puedes editar este formulario una vez.</p>
            <p>
              Si consideras que se trata de un error, intenta comunicarte con el
              selector que te haya enviado el link, o con{" "}
              <b>atraccioneinclusion@konecta-group.com</b>
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};
